<script>
  // import HorizontalLayout from "../routes/HorizontalLayout/Index.svelte";
  import VerticalLayout from "../pages/VerticalLayout/Index.svelte";

  let component = VerticalLayout;
  
  //document.body.setAttribute("data-layout", "horizontal");
  
</script>

<svelte:component this={component}>
  <slot />
</svelte:component>